
<nav id="navHeader" class="navbar navbar-expand-lg bg-white navbar-white p-1 nav-header-pfm fixed-top shadow-sm">
    <div class="container-fluid p-0">
      <div class="col-lg-3 col-sm-6 px-2 px-lg-5 px-md-5 col-md-3">
        <a class="navbar-brand m-0 p-0" [routerLink]="'/member-portal/dashboard'">
          <img loading="lazy" src="assets/images/logo-finsights/logo-black.png" class="header-logo" loading="lazy" bh-id="banner-default-logo-img"/>
        </a>
      </div>
      <div class="float-end">
        <button *ngIf="ShowMenu && ShowMenuMobile" class="navbar-toggler" id="button-menu" type="button"
          data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
          aria-expanded="false">
          &#9776;
        </button>
      </div>
      <div *ngIf="ShowMenu" class="col-lg-7 collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <ng-container *ngFor="let item of menuItems; index as i">
            <li *ngIf="item && item?.SubOptions?.length == 0; else dropdownMenuShow" class="nav-item px-5 px-sm-5 px-md-5 px-lg-2"
              id="menuItem{{ item?.Id }}">
              <a id="menuItem{{ item?.Id }}" class="nav-link" [routerLinkActive]="['active']" routerLink="{{ item?.Path }}" data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show">
                {{ item?.Title }}
              </a>
            </li>
            <ng-template #dropdownMenuShow>
              <li class="nav-item px-xs-5 px-5 px-md-5 px-lg-2" ngbDropdown id="menuItemDropdown{{ item?.Id }}" *ngIf="item">
                <a *ngIf="item?.Path?.length != 0; else dropdownMenuShowWithOutLink" ngbDropdownToggle class="nav-link"
                  tabindex="{{ item?.Id }}" id="navbarDropdown{{ item?.Id }}" role="button">
                  <a id="menuItem{{ item?.Id }}" class="nav-link d-inline" [routerLinkActive]="['active']" routerLink="{{ item?.Path }}"
                    data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                    {{ item?.Title }}
                  </a>
                  <div class="float-end">
                    <i class="fas fa-caret-down"></i>
                  </div>
                </a>
                <ng-template #dropdownMenuShowWithOutLink>
                  <a ngbDropdownToggle class="nav-link" tabindex="{{ item?.Id }}" id="navbarDropdown{{ item?.Id }}">
                    {{ item?.Title }}
                    <div class="nav-link-custom float-end">
                      <i class="fas fa-caret-down"></i>
                    </div>
                  </a>
                </ng-template>
                <div ngbDropdownMenu attr.aria-labelledby="navbarDropdown{{ item?.Id }}"
                  class="dropdown-menu dropdown-menu-main" id="menuItemDropdownContent{{ item?.Id }}">
                  <ng-container *ngFor="let childremItem of item?.SubOptions!">
                    <a *ngIf="childremItem" ngbDropdownItem routerLink="{{ childremItem?.Path }}"
                      data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                      id="O{{ item?.Id }}menuSubItem{{ childremItem?.Id }}">
                      {{ childremItem?.Title }}
                    </a>
                  </ng-container>
                </div>
              </li>
            </ng-template>
          </ng-container>
          <li class="nav-item px-5 d-block d-lg-none border-top border-secondary">
            <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" role="button"
              [routerLink]="'/member-portal/account-settings'" id="tooltip-dashboard-mobile-step-5">Account Settings</a>
            <div>
              <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" role="button"
                (click)="QuickTour()" id="tooltip-dashboard-mobile-step-6">Quick Tour</a>
            </div> <a class="nav-link text-danger" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
              role="button" (click)="Logout()" id="tooltip-dashboard-mobile-step-8">Log out</a>
          </li>
        </ul>
      </div>
      <div *ngIf="ShowMenu" class="col-1 px-2 px-lg-5 px-md-5 d-flex justify-content-end d-none d-lg-flex"
        data-bs-toggle="collapse" aria-expanded="false">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item" ngbDropdown>
            <a class="nav-link p-0" role="button">
              <a class="d-inline text-dark" [routerLinkActive]="['active']" data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show">
                <i class="fas fa-user"></i>
              </a>
            </a>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-user" id="dropdown-menu-user">
              <a ngbDropdownItem data-bs-toggle="collapse" data-bs-target=".navbar-user-collapse.show" role="button"
                [routerLink]="'/member-portal/account-settings'" id="tooltip-dashboard-step-5">
                Account Settings
              </a>
              <div>
                <a ngbDropdownItem data-bs-toggle="collapse" data-bs-target=".navbar-user-collapse.show" role="button"
                  (click)="QuickTour()" id="tooltip-dashboard-step-6">
                  Quick Tour
                </a>
              </div>
              <a ngbDropdownItem class="text-danger" data-bs-toggle="collapse" data-bs-target=".navbar-user-collapse.show"
                role="button" (click)="Logout()" id="tooltip-dashboard-step-8">
                Log out
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div *ngIf="FunnelFlow?.PathLogo" class="col-lg-3 col-sm-6 px-1 px-lg-5 px-md-5 text-end">
        <img loading="lazy" class="header-cobrand-logo" [src]="FunnelFlow.PathLogo" loading="lazy" bh-id="banner-cobrand-img" >
      </div>
    </div>
  </nav>